function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.map.delete-all.js";
import "core-js/modules/esnext.map.every.js";
import "core-js/modules/esnext.map.filter.js";
import "core-js/modules/esnext.map.find.js";
import "core-js/modules/esnext.map.find-key.js";
import "core-js/modules/esnext.map.includes.js";
import "core-js/modules/esnext.map.key-of.js";
import "core-js/modules/esnext.map.map-keys.js";
import "core-js/modules/esnext.map.map-values.js";
import "core-js/modules/esnext.map.merge.js";
import "core-js/modules/esnext.map.reduce.js";
import "core-js/modules/esnext.map.some.js";
import "core-js/modules/esnext.map.update.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { useMutation } from '@vue/apollo-composable';
import { fundSetupI18nText } from '../../pages/portfolio/funds/edit/i18n.ts';
import { SfdrStrategyKind, useAddSfdrStrategyMutation, useGetSectionWithQuestionsQuery, useGetUserQuery } from '~/types/types';
import updateFundMutation from '~/graphql/mutations/account/UpdateFund.gql';
import deleteSfdrStrategyMutation from '~/graphql/mutations/account/DeleteSfdrStrategy.gql';
export default defineComponent({
  props: {
    sustainableObjectives: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    fundId: {
      type: Number,
      required: true
    },
    sectionId: {
      type: Number,
      required: true
    },
    fund: {
      type: Object,
      required: true
    }
  },
  setup: function setup(props) {
    var _useAddSfdrStrategyMu = useAddSfdrStrategyMutation(),
      addSfdrStrategy = _useAddSfdrStrategyMu.mutate;
    var _useMutation = useMutation(deleteSfdrStrategyMutation),
      deleteSfdrStrategy = _useMutation.mutate,
      deleteLoading = _useMutation.loading,
      onDone = _useMutation.onDone,
      onError = _useMutation.onError;
    var _useMutation2 = useMutation(updateFundMutation),
      updateFund = _useMutation2.mutate;
    var triggerUpdateFund = function triggerUpdateFund(key, val) {
      var input = {
        id: props.fundId
      };
      input[key] = val === undefined || val === '' ? null : val;
      updateFund({
        input: input
      });
    };
    var currentLoadingItemId = ref(null);
    onDone(function () {
      currentLoadingItemId.value = null;
      window.$nuxt.$emit('userError', {
        message: 'Sustainable objective was successfully deleted',
        color: 'green'
      });
    });
    onError(function () {
      window.$nuxt.$emit('userError', {
        message: 'An error occurred. Please try again'
      });
    });
    var _useGetUserQuery = useGetUserQuery(),
      userResult = _useGetUserQuery.result;
    var _useGetSectionWithQue = useGetSectionWithQuestionsQuery(computed(function () {
        return {
          id: props.sectionId,
          fundId: props.fundId
        };
      }), computed(function () {
        return {
          enabled: !!props.sectionId && !!props.fundId
        };
      })),
      sectionResult = _useGetSectionWithQue.result;
    var user = computed(function () {
      var _userResult$value;
      return ((_userResult$value = userResult.value) === null || _userResult$value === void 0 ? void 0 : _userResult$value.getUser) || {
        locale: 'en-US',
        isAdmin: false
      };
    });
    var currentLocale = computed(function () {
      // In case locale is 'en' - it returns 'en'.
      // In case locale is 'en-US' - it also returns 'en'.
      return user.value.locale.substring(0, 2);
    });
    var getValueByPath = function getValueByPath(path, dict) {
      return path.split('.').reduce(function (acc, cur) {
        return acc === null || acc === void 0 ? void 0 : acc[cur];
      }, dict);
    };
    var sectionQuestionsByIxId = computed(function () {
      var _sectionResult$value, _sectionResult$value$;
      var map = new Map();
      var children = ((_sectionResult$value = sectionResult.value) === null || _sectionResult$value === void 0 ? void 0 : (_sectionResult$value$ = _sectionResult$value.getSection) === null || _sectionResult$value$ === void 0 ? void 0 : _sectionResult$value$.children) || [];
      var _iterator = _createForOfIteratorHelper(children),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _child$question;
          var child = _step.value;
          if (child !== null && child !== void 0 && (_child$question = child.question) !== null && _child$question !== void 0 && _child$question.ixId) {
            map.set(child.question.ixId, child.question);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return map;
    });
    var sectionQuestionText = function sectionQuestionText(ixId, field, fallback) {
      var question = sectionQuestionsByIxId.value.get(ixId);
      return (question === null || question === void 0 ? void 0 : question[field]) || fallback;
    };
    var translate = function translate(key) {
      var _getValueByPath;
      var translation = (_getValueByPath = getValueByPath(key, fundSetupI18nText)) === null || _getValueByPath === void 0 ? void 0 : _getValueByPath[currentLocale.value];
      if (!translation) {
        console.warn(key, fundSetupI18nText === null || fundSetupI18nText === void 0 ? void 0 : fundSetupI18nText.questions);
      }
      return translation;
    };
    return {
      addSfdrStrategy: addSfdrStrategy,
      deleteSfdrStrategy: deleteSfdrStrategy,
      deleteLoading: deleteLoading,
      currentLoadingItemId: currentLoadingItemId,
      triggerUpdateFund: triggerUpdateFund,
      translate: translate,
      sectionQuestionText: sectionQuestionText
    };
  },
  data: function data() {
    return {};
  },
  methods: {
    triggerCreate: function triggerCreate() {
      this.addSfdrStrategy({
        input: {
          fundId: this.fundId,
          kind: SfdrStrategyKind.SustainableObjective
        }
      });
    },
    getItemStrategy: function getItemStrategy(item) {
      if (item.concept) return item.concept.label;
      return 'No sustainable objective defined';
    },
    handleDeleteSustainableObjective: function handleDeleteSustainableObjective(id, callback) {
      this.currentLoadingItemId = id;
      this.deleteSfdrStrategy({
        id: id
      });
      callback();
    }
  }
});